import styled from 'styled-components';
import colors from '../../../styles/colors';

const StyledCurve = styled.div`
    h1 {
        font-size: 1.4em;
        font-weight: 700;
    }

    span {
        color: ${colors['--bg-color']};
        font-weight: 500;
        font-size: 0.85em;
    }
`;

export {
    StyledCurve,
};
